export default __webpack_public_path__ + "static/media/Grupo6135.3fa5dee0.svg";